import { faTrash } from "@fortawesome/free-solid-svg-icons";
import React, { type FC } from "react";
import { useApiCall } from "../api/api";
import type { User } from "../api/dto";
import { ModalFooter } from "../components/layout/ModalProvider";
import { useRefresh } from "../components/RefreshController";

export const ManageUserLoginModal: FC<{ user: User }> = (props) => {
  const { manageUserLogin } = useApiCall();
  const reload = useRefresh();

  const confirm = async () => {
    await manageUserLogin(props.user.id, props.user.enabled);
    reload();
  };

  return (
    <>
      <p>
        {props.user.enabled ? (
          <>
            <strong>Let op!</strong> Weet je zeker dat de inlogrechten gebruiker{" "}
            <strong>{props.user.username}</strong> wilt intrekken?
          </>
        ) : (
          <>
            <strong>Let op!</strong> Weet je zeker dat de gebruiker{" "}
            <strong>{props.user.username}</strong> inlogrechten wilt toewijzen?
          </>
        )}
      </p>
      <ModalFooter icon={faTrash} text={"Opslaan"} onSubmit={confirm} />
    </>
  );
};
